import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useLang } from "@/contexts/LanguageContext";
import { fetchProducts } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import Reveal from "@/components/Reveal";

export default function Shop() {
  const { t } = useLang();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const filter = searchParams.get("filter");

  useEffect(() => {
    setLoading(true);
    fetchProducts().then((data) => {
      setProducts(data);
      setLoading(false);
    });
  }, []);

  const displayed = useMemo(() => {
    if (filter === "new") return products.filter((p) => p.new);
    return products;
  }, [products, filter]);

  return (
    <div data-testid="shop-page" className="pt-32 lg:pt-40 pb-32 px-6 lg:px-12 bg-maly-cream min-h-screen">
      <div className="max-w-[1600px] mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-20">
          <Reveal>
            <div className="font-body text-[11px] tracking-[0.3em] uppercase text-maly-navy/60 mb-6">
              {t.shop.overline}
            </div>
          </Reveal>
          <Reveal delay={100}>
            <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-light tracking-[-0.02em] leading-[1.02]">
              {filter === "new" ? t.common.newIn : t.shop.headline}
            </h1>
          </Reveal>
          <Reveal delay={200}>
            <p className="font-body text-base opacity-70 mt-6 leading-relaxed">{t.shop.sub}</p>
          </Reveal>
        </div>

        {loading ? (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-10">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="aspect-[3/4] bg-maly-creamDeep animate-pulse" />
            ))}
          </div>
        ) : (
          <div data-testid="shop-grid" className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-10">
            {displayed.map((p, i) => (
              <Reveal key={p.id} delay={i * 70}>
                <ProductCard product={p} index={i} />
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
